import { AcademicLevel, Campus, Consentement, Email, FirstName, LastName, MobilePhoneRequired, Salutation, Section, Specialites } from "services/validation"
import * as Yup from "yup"

const schema = Yup.object().shape({
  ...Consentement,
  lead: Yup.object().shape({
    ...AcademicLevel,
    ...Campus,
    ...Email,
    ...FirstName,
    ...LastName,
    ...MobilePhoneRequired,
    ...Salutation,
    ...Section
  }),
  ...Specialites
})

export default schema
